import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('filled', 'square-filled', 'SquareFilled', [["path",{"d":"M19 2h-14a3 3 0 0 0 -3 3v14a3 3 0 0 0 3 3h14a3 3 0 0 0 3 -3v-14a3 3 0 0 0 -3 -3z"}]]);